<template>
  <el-container style="height: 900px; border: 1px solid #eee" v-loading="loading">
    <el-aside width="200px;" style="height: 800px; background-color: rgb(164,191,236)">
      <el-menu :default-openeds="['1', '3']">
        <el-submenu index="1">
          <template slot="title"><i class="el-icon-message"></i>游戏分类</template>
          <el-menu-item-group>
            <el-menu-item index="1-1" v-for="(item,index) in classList" @click="clickClass(index)">{{ item.name }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header>
        <div style="display: flex; flex-direction: row">
          <div style="width: 20%;font-size: 22px">
            当前游戏类型：{{headType}}
          </div>
          <div style="width: 80%;text-align: right; font-size: 12px">
            <span @click="findGame"
                  style="padding: 10px;border-radius: 6px; background: #5FB878; color: white">查找游戏ID</span>
            <span @click="addGameClass"
                  style="padding: 10px;border-radius: 6px; background: #5FB878; color: white">添加游戏类型</span>
            <span @click="addGame"
                  style="padding: 10px;border-radius: 6px; background: #5FB878; color: white">添加{{ headType }}</span>
          </div>
        </div>
      </el-header>

      <el-main>
        <el-table :data="tableData" border height="700">
          <el-table-column prop="id" label="id" width="140"></el-table-column>
          <el-table-column prop="icon" label="封面" width="120">
            <template slot-scope="scope">
              <img :src="scope.row.icon" alt="" style="width: 120px;height: 60px; object-fit: cover">
            </template>
          </el-table-column>
          <el-table-column prop="title" label="游戏名称"></el-table-column>
          <el-table-column prop="hot" label="热度"></el-table-column>
          <el-table-column prop="size" label="大小"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click="myedit(scope.$index)">编辑
              </el-button>
              <el-button
                size="mini"
                type="success"
                @click="mydel(scope.$index)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :total="count">
        </el-pagination>
      </el-main>
	  <el-footer><el-link href="" target="_blank" class="pic">鲁ICP备2023042173号-1</el-link></el-footer>
    </el-container>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>确定删除这个游戏</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="deleteGame()">确 定</el-button>
    </span>
    </el-dialog>
    <el-dialog title="添加游戏" :visible.sync="addDialogFormVisible">
      <el-form :model="form" :rules="rulesForm" ref="form">
        <el-form-item label="游戏名称" prop="title" :label-width="formLabelWidth">
          <el-input v-model="form.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图片链接" prop="icon" :label-width="formLabelWidth">
          <el-input v-model="form.icon" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="热度" prop="hot" :label-width="formLabelWidth">
          <el-input v-model.number="form.hot" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="大小（单位G）" prop="size" :label-width="formLabelWidth">
          <el-input v-model="form.size" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveGame('form')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加游戏类型" :visible.sync="addClassFormVisible">
      <el-form :model="classData" :rules="rulesForm" ref="classData">
        <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
          <el-input v-model="classData.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addClassFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveGameClass('classData')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改游戏大小" :visible.sync="updateGameSizeVisible">
      <el-form :model="updateGame" :rules="rulesForm" ref="updateGame">
        <el-form-item label="大小（单位G）" prop="size" :label-width="formLabelWidth">
          <el-input v-model="updateGame.size" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateGameSizeVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveUpdate('updateGame')">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>

import utils from "../../Utils.vue";
import Utils from "../../Utils.vue";

export default {
  created() {
    if (utils.isLogin()) {
      this.loadClassType();
    } else {
      this.$message.error("请先登录")
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      classList: [],
      dialogVisible: false,
      addDialogFormVisible: false,
      addClassFormVisible: false,
	  updateGameSizeVisible: false,
      deleteId: 0,
      position: 0,
      headType: '',
      form: {
        title: '',
        icon: '',
        hot: '',
        size: ''
      },
      rulesForm: {
        title: [
          {required: true, message: '请输入名称', trigger: 'blur'},
          {min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur'}
        ],
        icon: [
          {required: true, message: '请输入图片链接', trigger: 'blur'},
          {min: 1, max: 500, message: '长度在 1 到 100 个字符', trigger: 'blur'}
        ],
        hot: [
          {required: true, message: '请输入热度'},
          {type: 'number', message: '热度必须为数字'},
        ],
        size: [
          {required: true, message: '请输入大小'}
        ],
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
          {min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur'}
        ]
      },
      classData: {
        name: ''
      },
	  updateGame: {
		size: 0,
		id: 0
	  },
      formLabelWidth: '120px',
      page: 1,
      count: 1
    }
  },
  methods: {
    loadClassType() {
      const _this = this;
      _this.loading = true;
      this.$http.get(this.$global.baseUrl + 'getClassList')
        .then((response) => {
            if (response.data.state === 0) {
              _this.classList = response.data.list;
              if (_this.classList.length > 0) {
                _this.headType = _this.classList[0].name
                _this.loadGameInfo(0)
              } else {
                _this.loading = false;
              }
            } else {
              _this.loading = false;
              this.$message.success(response.data.message);
              _this.classList = []
            }
        })
        .catch((error) => {
          console.log(error)
          _this.loading = false;
        });
    },
    handleCurrentChange(page) {
      console.log(page)
      this.page = page;
      this.loadGameInfo(this.position)
    },
    clickClass(index) {
      this.page = 1;
      this.loadGameInfo(index)
    },
    loadGameInfo(index) {
      this.loading = true;
      const _this = this;
      _this.position = index;
      _this.headType = _this.classList[index].name
      this.$http.get(this.$global.baseUrl + 'getGameList?clazz=' + _this.classList[index].id + "&page="+_this.page)
        .then((response) => {
          if (response.data.state === 0) {
            _this.tableData = response.data.list;
            _this.count = response.data.count;
          } else {
            _this.tableData = [];
            this.$message.success(response.data.message);
          }
          _this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error)
        });
    },
    myedit(index) {
      console.log("=======编辑=======")
	  this.updateGame.size = this.deleteId = this.tableData[index].size;
	  this.updateGame.id = this.deleteId = this.tableData[index].id;
	  this.updateGameSizeVisible = true;
    },
    mydel(index) {
      console.log("=======删除=======")
      this.deleteId = this.tableData[index].id;
      this.dialogVisible = true;
    },
    deleteGame() {
      const _this = this;
      this.dialogVisible = false;
      this.loading = true;
      const param = 'id=' + this.deleteId
        + "&userid="+Utils.getUserId() + "&token="+Utils.getToken()
      this.$http.get(this.$global.baseUrl + 'deleteGame?' + param)
        .then((response) => {
            if (response.data.state === 0) {
              _this.loadGameInfo(_this.position)
            } else {
              _this.loading = false;
              this.$message.success(response.data.message);
            }
        })
        .catch((error) => {
          _this.loading = false;
        });
    },
    addGame() {
      this.addDialogFormVisible = true
    },
    addGameClass() {
      this.addClassFormVisible = true
    },
    saveGame(form) {
      const _this = this;
      this.$refs[form].validate((valid) => {
        if (valid) {
          let reg = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
          if (!reg.test(_this.form.size)) {
            _this.$message.error("输入的大小有误")
            return false;
          }
          _this.addDialogFormVisible = false;
          _this.loading = true;
          console.log("=======saveGame==  =====")
          const param = 'title=' + _this.form.title + '&icon='
            + _this.form.icon + '&hot=' + this.form.hot + '&size='
            + _this.form.size + '&classId=' + this.classList[_this.position].id
            + "&userid="+Utils.getUserId() + "&token="+Utils.getToken()
          this.$http.get(this.$global.baseUrl + 'addGameGet?' + param).then((response) => {
            if (response.data.state === 0) {
              _this.loadGameInfo(_this.position)
              _this.$message.success("添加成功");
            } else {
              _this.$message.success(response.data.message);
            }
            _this.loading = false;
          }).catch((error) => {
            _this.$message.error("添加失敗，" + error.data.reason)
            _this.loading = false;
          });
          _this.$refs[form].resetFields();
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    saveGameClass(form) {
      console.log("=======saveGame==  =====")
      const _this = this;
      _this.loading = true;
      _this.addClassFormVisible = false;
      this.$refs[form].validate((valid) => {
        if (valid) {
          const param = 'name=' + _this.classData.name + "&userid="+Utils.getUserId() + "&token="+Utils.getToken()
          this.$http.get(this.$global.baseUrl + 'addClass?' + param).then((response) => {
            if (response.data.state === 0) {
              _this.loadClassType()
              _this.$message.success("添加成功");
            } else {
              _this.$message.success(response.data.message);
            }
            _this.loading = false;
          }).catch((error) => {
            _this.$message.error("添加失敗，" + error.data.reason)
            _this.loading = false;
          });
          _this.$refs[form].resetFields();
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
	saveUpdate(form) {
      const _this = this;
      _this.loading = true;
      _this.updateGameSizeVisible = false;
      this.$refs[form].validate((valid) => {
        if (valid) {
		  const param = 'id=' + _this.updateGame.id + "&size=" + _this.updateGame.size + "&userid="+Utils.getUserId() + "&token="+Utils.getToken()
          this.$http.get(this.$global.baseUrl + 'updateGameSize?' + param).then((response) => {
            if (response.data.state === 0) {
              _this.loadGameInfo(_this.position)
              _this.$message.success("修改成功");
            } else {
              _this.$message.success(response.data.message);
            }
            _this.loading = false;
          }).catch((error) => {
            _this.$message.error("修改失敗，" + error.data.reason)
            _this.loading = false;
          });
          _this.$refs[form].resetFields();
        } else {
          console.log('error submit!!');
          return false;
        }
      })
	},
    findGame() {
      this.$router.push('/findGame');
    }
  }
};
</script>

<style>
.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}
.pic {
position: fixed;
bottom: 0;
left: 50%;/*相对于可视区窗口，距离窗口左边50%个可视区窗口*/
margin-left:-100px ;/*表格左边距离浏览器左边50%，向左偏移一半的身位表格即可居中*/
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue